import React, { Component } from "react";
import Logout from "../assets/logout.svg";
import Back from "../assets/back.svg";
import { toast } from "react-toastify";
import Loading from "../components/Loading";
import qs from "qs";
import {
  BaseUrl,
  Authorization,
  BaseUrlPublic,
  isUser,
  LogoutFunction,
  ServerSocket,
} from "../static.js";
import Tooltip from "@mui/material/Tooltip";

import MyOrderItem from "../components/MyOrderItem.js";
import Masonry from "react-masonry-css";

const breakpointColumnsObj = {
  default: 4,
  1200: 3,
  850: 2,
  600: 1,
};

export default class MyOrder extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dataLoading: true,
      orderList: [],
      resID: null,
      menuList: [],
      defaultLanguage: 1,
      userType: "",
      userTypeName: "",
    };

    this.exitOrder = this.exitOrder.bind(this);
    this.reciveOrder = this.reciveOrder.bind(this);
    this.reciveOrderListener = this.reciveOrderListener.bind(this);
    this.editOrderListener = this.editOrderListener.bind(this);
    this.changeOrderStatusListener = this.changeOrderStatusListener.bind(this);
  }

  componentDidMount() {
    console.log(this.props.location);

    let userType = "";
    let userTypeName = "";

    if (
      this.props.location.pathname
        .toLowerCase()
        .trim()
        .endsWith("/managerorderlist")
    ) {
      userType = "Manager";
      userTypeName = "مدیر داخلی";
    } else if (
      this.props.location.pathname
        .toLowerCase()
        .trim()
        .endsWith("/waiterorderlist")
    ) {
      userType = "Waiter";
      userTypeName = "گارسون";
    } else if (
      this.props.location.pathname
        .toLowerCase()
        .trim()
        .endsWith("/kdsorderlist")
    ) {
      userType = "KDS";
      userTypeName = "آشپزخانه";
    } else if (
      this.props.location.pathname
        .toLowerCase()
        .trim()
        .endsWith("/cashierorderlist")
    ) {
      userType = "Cashier";
      userTypeName = "صندق‌دار";
    }
    // switch (
    //   qs
    //     .parse(this.props.location.search, {
    //       ignoreQueryPrefix: true,
    //     })
    //     .type.toLowerCase()
    //     .trim()
    // ) {
    //   case "manager": {
    //     userType = "Manager";
    //     userTypeName = "مدیر داخلی";
    //     break;
    //   }
    //   case "waiter": {
    //     userType = "Waiter";
    //     userTypeName = "گارسون";
    //     break;
    //   }
    //   case "kds": {
    //     userType = "KDS";
    //     userTypeName = "آشپزخانه";
    //     break;
    //   }
    //   case "cashier": {
    //     userType = "Cashier";
    //     userTypeName = "صندق‌دار";
    //     break;
    //   }
    //   default:
    //     break;
    // }
    this.setState(
      {
        userType: userType,
        userTypeName: userTypeName,
      },
      () => {
        this.findBusinessWithCode();
      }
    );
  }

  findBusinessWithCode() {
    let data = {
      businessCode: this.props.match.params.id,
    };

    data = Object.assign(data, Authorization());

    this.setState({ dataLoading: true });

    fetch(BaseUrl + "findBusinessWithCode", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          this.setState(
            {
              resID: result.result[0].id,
              defaultLanguage: result.result[0].defaultLanguage,
            },
            () => {
              this.readMyOrderList(true);
            }
          );
        } else if (result.status === 401) {
          LogoutFunction();
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ dataLoading: false });
      });
  }

  setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  componentWillUnmount() {
    this.removeSockets();
  }

  removeSockets() {
    try {
      ServerSocket.off("exitOrder");
      ServerSocket.off("reciveOrder", this.reciveOrderListener);
      ServerSocket.off("reciveOrder-edited", this.editOrderListener);
      ServerSocket.off("changeOrderStatus", this.changeOrderStatusListener);
      // clearInterval(this.timer);
    } catch (error) {}
  }

  // startTimer() {
  //   clearInterval(this.timer);
  //   this.timer = setInterval(this.countDown, 10000);
  // }

  // countDown() {
  //   // if (this.state.orderSelected) {
  //   //   if (this.state.orderList.length > 0) {
  //   //     this.getOrders(true);
  //   //   } else {
  //   //     this.getOrders(false);
  //   //   }
  //   // }
  //   this.readMyOrderList(false);
  // }

  exitOrder(data) {
    let elist = JSON.parse(JSON.stringify(this.state.orderList));

    let index = 0;
    for (let i = 0; i < elist.length; i++) {
      if (elist[i].orderId === data.orderId) index = i;
    }
    elist.splice(index, 1);

    this.setState({ orderList: [] }, () => {
      this.setState({ orderList: elist }, () => {
        console.log("orderList: ", this.state.orderList);
      });
    });
  }

  reciveOrder(data) {
    console.log(data);
    if (data.BUT !== this.state.userType) {
      let place = " ";
      switch (data.BUT) {
        case "KDS": {
          place = "آشپزخانه: ";
          break;
        }
        case "Manager": {
          place = "مدیر داخلی: ";
          break;
        }
        case "Cashier": {
          place = "صندق‌دار: ";
          break;
        }
        case "Waiter": {
          place = "گارسون: ";
          break;
        }
        default:
          break;
      }
      console.log("258");
      if (place) {
        toast.success(place + "سفارش جدید برای  " + data.orderStationName, {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 6000,
          toastClassName: "toast",
          onClick: () => {
            this.props.onMyOrderClick(localStorage.getItem("code"), data.BUT);
            this.setState({ dataLoading: true }, () => {
              this.removeSockets();
              this.componentDidMount();
            });
          },
        });
      }
      return;
    }
    let elist = JSON.parse(JSON.stringify(this.state.orderList));
    data.items.forEach((element) => {
      element.selected = false;
    });

    let found = false;
    elist.forEach((element) => {
      if (element.orderId === data.orderId) {
        found = true;
        element.items = data.items;
        element.otherItems = data.otherItems;
      }
    });

    if (!found) elist.push(data);

    this.setState({ orderList: [] }, () => {
      this.setState({ orderList: elist }, () => {
        console.log("orderList: ", this.state.orderList);
      });
    });
  }

  reciveOrderListener(data) {
    this.reciveOrder(data);
  }

  editOrderListener(data) {
    console.log("editOrderListener: ", data);
    let elist = JSON.parse(JSON.stringify(this.state.orderList));
    elist.forEach((element) => {
      if (element.orderId === data.orderId) {
        element.descr = data.descr;
        element.items = data.items;
        element.otherItems = data.otherItems;
        element.OSEdited = data.OSEdited;
        element.isEdited = data.isEdited;
        element.isDeleted = data.isDeleted;
        element.descrEdited = data.descrEdited;
        element.orderStationName = data.orderStationName;
      }
    });

    let orders = JSON.parse(JSON.stringify(elist));
    orders.forEach((element) => {
      element.items.forEach((element1) => {
        if (this.getCookie(element1.id)) element1.selected = true;
        else element1.selected = false;
      });
    });

    this.setState({ orderList: [] }, () => {
      this.setState({ orderList: orders }, () => {
        console.log("orderList: ", this.state.orderList);
      });
    });
  }

  changeOrderStatusListener(data) {
    console.log("changeOrderStatusListener: ", data);
    if (data.status === 4) {
      let elist = JSON.parse(JSON.stringify(this.state.orderList));
      elist.forEach((element) => {
        if (element.orderId === data.orderId) {
          element.isDeleted = true;
          element.items.forEach((element1) => {
            element1.isDeleted = true;
          });
        }
      });
      this.setState({ orderList: [] }, () => {
        this.setState({ orderList: elist });
      });
    }
  }

  readMyOrderList(first) {
    let data = {
      businessCode: this.props.match.params.id,
      businessUserType: this.state.userType,
    };
    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "readMyOrderList", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          ServerSocket.on("exitOrder", (data) => {
            console.log("exitOrder: ", data);
            this.exitOrder(data);
          });

          ServerSocket.on("reciveOrder", this.reciveOrderListener);
          ServerSocket.on("reciveOrder-edited", this.editOrderListener);
          // ServerSocket.on("editOrder", this.editOrderListener);
          ServerSocket.on("changeOrderStatus", this.changeOrderStatusListener);

          let orders = JSON.parse(JSON.stringify(result.orderList));
          orders.forEach((element) => {
            element.items.forEach((element1) => {
              if (this.getCookie(element1.id)) element1.selected = true;
              else element1.selected = false;

              // let foodname = "";
              // element1.nameObj.forEach((element2) => {
              //   if (element2.languageId === 1) {
              //     foodname = element2.name;
              //   }
              // });

              // if (foodname === "") {
              //   element1.nameObj.forEach((element2) => {
              //     if (element2.languageId === this.state.defaultLanguage) {
              //       foodname = element2.name;
              //     }
              //   });
              // }

              // if (foodname === "") {
              //   element1.nameObj.forEach((element2) => {
              //     if (foodname === "" && element2.name !== "") {
              //       foodname = element2.name;
              //     }
              //   });
              // }

              // element1.foodName = foodname;
            });

            // element.otherItems.forEach((element1) => {
            //   let foodname = "";
            //   element1.nameObj.forEach((element2) => {
            //     if (element2.languageId === 1) {
            //       foodname = element2.name;
            //     }
            //   });

            //   if (foodname === "") {
            //     element1.nameObj.forEach((element2) => {
            //       if (element2.languageId === this.state.defaultLanguage) {
            //         foodname = element2.name;
            //       }
            //     });
            //   }

            //   if (foodname === "") {
            //     element1.nameObj.forEach((element2) => {
            //       if (foodname === "" && element2.name !== "") {
            //         foodname = element2.name;
            //       }
            //     });
            //   }

            //   element1.foodName = foodname;
            // });
          });

          this.setState({
            dataLoading: false,
            orderList: orders,
          });
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  onBack() {
    this.props.history.push("/Restaurants/" + this.props.match.params.id);
  }

  onLogout() {
    LogoutFunction();
  }

  uncheckItem(id) {
    let orders = JSON.parse(JSON.stringify(this.state.orderList));
    orders.every((element) => {
      let found = false;
      element.items.every((element1) => {
        if (element1.id === id) {
          element1.selected = false;
          this.setCookie(id, "false", -1);
          found = true;
          return false;
        }
        return true;
      });
      if (found) return false;
      return true;
    });

    this.setState({
      orderList: orders,
    });
  }

  checkItem(id) {
    let orders = JSON.parse(JSON.stringify(this.state.orderList));
    orders.every((element) => {
      let found = false;
      element.items.every((element1) => {
        if (element1.id === id) {
          element1.selected = true;
          this.setCookie(id, "true", 1);
          return false;
        }
        return true;
      });
      if (found) return false;
      return true;
    });

    this.setState({
      orderList: orders,
    });
  }

  completeOrder(id) {
    console.log(this.state.orderList);
    let orderItemList = [];
    let prepareStatus = 0;
    this.state.orderList.forEach((element) => {
      element.items.forEach((element1) => {
        if (element1.orderId === id) {
          if (element1.isDeleted === 0) prepareStatus = element1.prepareStatus;
          orderItemList.push(element1.id);
        }
      });
    });

    let data = {
      businessCode: this.props.match.params.id,
      orderId: id,
      orderItemList: orderItemList,
      prepareStatus: prepareStatus,
    };
    data = Object.assign(data, Authorization());
    console.log(data);
    // return
    fetch(BaseUrl + "setOrderCompleteFromMYPanel", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          // this.readMyOrderList(false);
        } else {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  render() {
    if (!this.state.dataLoading)
      return (
        <div className="Login">
          <div className="header">
            <div
              onClick={this.onBack.bind(this)}
              className="linkStyle backButton"
            >
              <img
                src={Back}
                alt=""
                className="backButtonIcon"
                style={{ transform: "rotate(180deg)" }}
              />
              بازگشت
            </div>
            <Tooltip title="خروج">
              <div
                onClick={this.onLogout.bind(this)}
                className="linkStyle backButton"
                // data-tip="خروج"
                // data-place="bottom"
              >
                <img src={Logout} alt="" className="backButtonIcon" />
              </div>
            </Tooltip>
          </div>
          <div className="LoginContent">
            <div className="RestaurantsListTitle">
              لیست سفارشات {this.state.userTypeName}
            </div>
            <div
              style={{
                width: "95vw",
                maxWidth: "1200px",
                marginTop: "20px",
              }}
            >
              {this.state.orderList.length > 0 && (
                <Masonry
                  breakpointCols={breakpointColumnsObj}
                  className="my-masonry-grid"
                  columnClassName="my-masonry-grid_column"
                >
                  {this.state.orderList.map((item, i) => {
                    return (
                      <MyOrderItem
                        key={i}
                        items={item.items}
                        otherItems={item.otherItems}
                        uncheckItem={this.uncheckItem.bind(this)}
                        checkItem={this.checkItem.bind(this)}
                        completeOrder={this.completeOrder.bind(this)}
                        stationName={item.orderStationName}
                        orderId={item.orderId}
                        descr={item.descr}
                        isEdited={item.isEdited}
                        isDeleted={item.isDeleted}
                        OSEdited={item.OSEdited}
                        descrEdited={item.descrEdited}
                      />
                    );
                  })}
                </Masonry>
              )}
              {this.state.orderList.length === 0 && (
                <div
                  style={{
                    width: "100%",
                    minHeight: "50vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    color: "var(--gray3)",
                  }}
                >
                  در حال حاضر سفارشی وجود ندارد
                </div>
              )}
            </div>
          </div>
        </div>
      );
    else return <Loading />;
  }
}
